// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 773) return "static/chunks/773-d755383c43918d4a.js";
	if (chunkId === 916) return "static/chunks/916-19a0c2851c0e488f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"431":"17097dcd3747c33e","929":"050b74cc83249153","948":"8ca176ffd0c32bb8"}[chunkId] + ".js";
};